import { Market, StateOfOperation } from '@endpoint/endpoint-bff-graphql-schema';

export const isSupportedSignUpState = (activeMarkets: Market[], state?: StateOfOperation | undefined): Boolean => {
  return activeMarkets.some((m) => m.state === state);
};
